import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import GlobalHsCodeComponent from '../components/global-hs-code.component';
import { selectGlobalHSCodesQueryItems } from '../../../../../redux/global-hs-codes/selector';
import { globalHSCodes } from '../../../../../redux/global-hs-codes/action';
import { domains } from '../../../../../redux/domains/action';
import { selectDomainsListItems } from '../../../../../redux/domains/selector';

const GlobalHSCode = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectGlobalHSCodesQueryItems)
  const domainItems = useSelector(selectDomainsListItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [selectedGlobalHsCodes, setSelectedGlobalHsCodes] = useState<any>([])

  const fetchGlobalHsCodesById = () => {
    dispatch(globalHSCodes.query({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-hscodes/dbn-fetch-detail`,
      entity: 'globalHSCodes',
      jsonData:
      {
        Context: {},
        Records: [
          {
            Id: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const parentDomain = domainItems?.result?.items?.filter(
    (subDomainData: any) => subDomainData.IsSubDomain === false
  )

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedGlobalHsCodes({ ...selectedGlobalHsCodes, [field]: event });
  }

  const fetchDomainsList = () => {
    // dispatch(domains.list({
    //   url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/domains/list`,
    //   entity: 'domains',
    //   jsonData: {}
    // }))
  }

  useEffect(() => {
    fetchDomainsList();
    if (parmas?.id > 0) {
      fetchGlobalHsCodesById();
      setIsLoading(false)
    }
    else {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    if (isQuery) {
      setSelectedGlobalHsCodes(queryItems?.result?.items)
    }
  }, [isQuery])

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(globalHSCodes.resetAction({ actionType: 'update' }))
      await dispatch(globalHSCodes.update({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-hscodes`,
        entity: 'globalHSCodes',
        jsonData: {
          Context: {},
          Records: [
            {
              ...selectedGlobalHsCodes
            }
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(globalHSCodes.resetAction({ actionType: 'create' }))
      await dispatch(globalHSCodes.create({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-hscodes`,
        entity: 'globalHSCodes',
        jsonData: {
          Context: {},
          Records: [
            {
              ...selectedGlobalHsCodes
            }
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate(-1)
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <GlobalHsCodeComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedGlobalHsCodes={selectedGlobalHsCodes}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )

}

export default GlobalHSCode;
